import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

/**
 * Generic auth guard. Routes can declare a `roles` array in `data`:
 *   { path: 'admin', canActivate: [authGuard], data: { roles: ['admin'] } }
 */
const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean> => {
  const { authenticated, grantedRoles, keycloak } = authData;
  const router = inject(Router);

  if (!authenticated) {
    await keycloak.login({ redirectUri: window.location.origin + _state.url });
    return false;
  }

  const requiredRoles: string[] = route.data['roles'] ?? [];
  if (requiredRoles.length === 0) {
    return true;
  }

  const hasRole = requiredRoles.some(
    (role) =>
      grantedRoles.realmRoles.includes(role) ||
      Object.values(grantedRoles.resourceRoles).some((roles) =>
        roles.includes(role)
      )
  );

  if (!hasRole) {
    router.navigate(['/forbidden']);
    return false;
  }

  return true;
};

export const authGuard: CanActivateFn = createAuthGuard<CanActivateFn>(isAccessAllowed);
